export default {
	"searchDemo": {
		"searchBy": "search engine model",
		"searchKey": "search term",
		"searchKeyList": "Hot word case",
		"account": "account",
		"device": "tracking device",
		"users": "personnel",
		"capacity": "capacity",
		"hotKeyList": "Hot word backfill case",
		"mobile": "contact number",
		"hotKeyMoreList": "Hot word multi-dimensional case"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/search/search.js